import React from 'react';
import ConfigureClientView from './ConfigureClientView';
import routes from 'src/routes';
import { Application } from 'src/constants/application.const';
import { useAppPermission } from 'src/hooks/useAppPermission';

type ConfigureClientProps = {};

const ConfigureClient: React.FC<ConfigureClientProps> = () => {
    const [{ isAllowed }, redirect] = useAppPermission(Application.Nucleus.id, ['ra_client_management']);

    if (!isAllowed) {
      return redirect(routes.optCenter);
    }
    return <ConfigureClientView />;
};

export default ConfigureClient;
